import { Filters } from './Filters';
import { TableComponent } from '../../../components/Table';
import { IReassigmentProvider } from '../../../interfaces/service/ReassignmentServiceManagerInterface';
import { Column } from 'primereact/column';
import { createColumnsTable } from '../utils';

interface ITableReassignment {
  serviceReassignment: IReassigmentProvider;
}

export const TableReassigment = (props: ITableReassignment) => {
  const { serviceReassignment } = props;

  const getColumnsToDisplayIntable = () => {
    const _columnsTable = createColumnsTable(serviceReassignment);
    let columns = _columnsTable.map((column: any, index: any) => {
      const key = index.toString();
      return (
        <Column
          key={key}
          field={column.field}
          header={column.header}
          bodyClassName={'!text-grey !text-sm'}
          headerClassName={'!text-black !justify-between !bg-white'}
          style={{ flexGrow: 1, flexBasis: '100px' }}
          sortable={column.sortable}
          body={column.body}
        />
      );
    });

    return columns;
  };

  return (
    <>
      <div className="w-full rounded-b-lg flex items-center mb-3 bg-white shadow-2xl">
        <Filters serviceReassignment={serviceReassignment} />
      </div>
      <div className="h-full flex flex-col w-full overflow-y-auto relative p-4 bg-white rounded-lg shadow-2xl">
        <div className="flex w-full h-full items-center">
          <TableComponent
            value={serviceReassignment.samTableData}
            sortField="name"
            responsiveLayout="scroll"
            className="flex h-full w-full m-3 relative rounded"
            resizableColumns={true}
            setSort={serviceReassignment.setSort}
            sort={serviceReassignment.sort}
            reorderableColumns={true}
            OnEmptyMessage="No se encontraron registros, seleccione algún filtro y presione el botón 'Enviar' para mostrar resultados"
            loading={false}
            filters={serviceReassignment.filters}
            paginator={true}
            rowsPerPageOptions={true}>
            {serviceReassignment.samTableData.length > 0
              ? getColumnsToDisplayIntable()
              : null}
          </TableComponent>
        </div>
      </div>
    </>
  );
};
